module.exports = __webpack_public_path__ + "img/echart-ys.1969e07b.png";